import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

import { propsFilter } from '@utils/propsFilter';

export const sxStyles = {
  contentWrap: {
    padding: '2.5rem 1.5rem',
    borderTop: `1px solid ${coreThemeColors.grey[300]}`,
  },
  requirementsList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
    padding: '1.5rem 4.5rem 0.75rem',
  },
  greyColor: (theme: Theme) => ({
    color: theme.palette.grey['600'],
  }),
  greenTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  teacherTitle: {
    display: 'flex',
    margin: '1.5rem 0 1rem',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },
  },
  teacherEvaluationWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2rem',
  },
  assignedDate: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1rem',
  },
  divider: {
    margin: '0 1rem',
    minHeight: '1.25rem',
    borderRight: `1px solid ${coreThemeColors.grey[300]}`,
  },
};

export const StyledCardWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette.common.white,
  border: `1px solid ${coreThemeColors.grey[300]}`,
  borderRadius: '12px',
}));

export const StyledInfoItemsWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '1rem',
  marginBottom: '2rem',

  [theme.breakpoints.down('sm')]: {
    gap: '1rem 0',
  },
}));

export const StyledRequirementItem = styled(CoreBox, {
  shouldForwardProp: propsFilter(['isDisable', 'isSubmitted']),
})<{ isDisable: boolean; isSubmitted?: boolean }>(({ isDisable, isSubmitted, theme }) => ({
  padding: '1.25rem',
  maxWidth: '240px',
  width: '100%',
  textAlign: 'center',
  opacity: isDisable ? 0.4 : 'initial',
  borderRadius: '16px',
  transition: 'background-color 0.5s',

  '&:hover': {
    cursor: isDisable ? 'auto' : 'pointer',
    backgroundColor: isDisable ? 'none' : theme.palette.grey['100'],
  },

  '& > svg:first-of-type': {
    marginBottom: '0.5rem',
    fill: isSubmitted && coreThemeColors.primary.main,
    fillOpacity: isSubmitted && 1,
  },
}));

export const StyledTeacherInfo = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',

  '& > div:first-of-type': {
    display: 'flex',
    marginBottom: '0.5rem',
  },
}));

export const StyledRecommendersWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '16px',
  background: theme.palette.grey['100'],
  padding: '1.5rem',
  border: `1px solid ${coreThemeColors.grey[300]}`,
}));
